(() => {
  if (window.upupSavedPiecesReady) return;
  window.upupSavedPiecesReady = true;
  const key = 'upup.saved-pieces.v1';
  let selection = [], persistent = true, lastTrigger;
  const safeProductUrl = value => {
    try {
      const url = new URL(value, location.origin);
      return ['http:', 'https:'].includes(url.protocol) &&
        [location.hostname, 'uhts4u-2t.myshopify.com'].includes(url.hostname) &&
        url.pathname.startsWith('/products/') ? url.href : null;
    } catch { return null; }
  };
  const safeImage = value => {
    if (!value) return '';
    try { const url = new URL(value, location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  try {
    const saved = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(saved)) selection = saved.filter(item => item && typeof item.title === 'string' && safeProductUrl(item.url)).slice(0, 100).map(item => ({title:item.title.slice(0,300),url:safeProductUrl(item.url),image:safeImage(item.image)}));
  } catch { persistent = false; }
  const announce = text => { const target = document.querySelector('[data-save-status]'); if (target) target.textContent = text; };
  const persist = () => { try { localStorage.setItem(key, JSON.stringify(selection)); } catch { persistent = false; } };
  function refresh() {
    document.querySelectorAll('[data-save-piece]').forEach(button => {
      const saved = selection.some(item => item.url === safeProductUrl(button.dataset.productUrl));
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Unsave' : 'Save'} ${button.dataset.productTitle}`);
    });
    document.querySelectorAll('[data-open-saved]').forEach(button => { button.hidden = false; });
    document.querySelectorAll('[data-saved-count]').forEach(count => { count.textContent = String(selection.length); count.hidden = selection.length === 0; });
  }
  function drawList() {
    const list = document.querySelector('[data-saved-list]');
    if (!list) return;
    list.replaceChildren();
    if (!selection.length) {
      const empty = document.createElement('p'); empty.className = 'saved-empty'; empty.textContent = 'Tap the heart on a piece you love to save it here.'; list.append(empty); return;
    }
    for (const item of selection) {
      const row = document.createElement('div'); row.className = 'saved-row';
      const link = document.createElement('a'); link.href = item.url;
      if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.loading = 'lazy'; image.width = 84; image.height = 84; link.append(image); }
      const title = document.createElement('span'); title.textContent = item.title; link.append(title);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = 'Remove'; remove.dataset.removeSaved = item.url; remove.setAttribute('aria-label', `Remove ${item.title} from saved pieces`);
      row.append(link, remove); list.append(row);
    }
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const save = target.closest('[data-save-piece]');
    if (save) {
      const url = safeProductUrl(save.dataset.productUrl); if (!url) return;
      const index = selection.findIndex(item => item.url === url);
      if (index >= 0) selection.splice(index, 1);
      else { if (selection.length >= 100) { announce('You can save up to 100 pieces. Remove one to add another.'); return; } selection.push({url,title:save.dataset.productTitle.slice(0,300),image:safeImage(save.dataset.productImage)}); }
      persist(); refresh(); announce(index >= 0 ? 'Piece removed from your selection.' : persistent ? 'Piece saved to your selection.' : 'Piece saved for this visit. Browser storage is unavailable.');
    }
    if (target.closest('[data-open-saved]')) {
      const dialog = document.querySelector('[data-saved-dialog]'); if (!dialog) return;
      lastTrigger = target.closest('[data-open-saved]'); drawList(); if (document.body.classList.contains('upup-home')) dialog.show(); else dialog.showModal();
    }
    if (target.closest('[data-close-saved]')) { document.querySelector('[data-saved-dialog]')?.close(); lastTrigger?.focus(); }
    const remove = target.closest('[data-remove-saved]');
    if (remove) { selection = selection.filter(item => item.url !== remove.dataset.removeSaved); persist(); refresh(); drawList(); announce('Piece removed from your selection.'); document.querySelector('[data-close-saved]')?.focus(); }
  });
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
